import React from 'react';
export function PrivacyHeader() {
  return <header className="sticky top-0 z-40 w-full bg-cream/85 backdrop-blur-md border-b border-slate-light" data-id="element-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center" data-id="element-25">
        <a href="#" className="flex items-center" data-id="element-26">
          <span className="font-serif text-3xl tracking-tight text-navy" data-id="element-27">
            WinePik
          </span>
        </a>
      </div>
    </header>;
}